export default "/_next/static/images/209e17f61bb92add66bdfa099eedcf30.png";